module.exports = __webpack_public_path__ + "static/media/dotted-menu-btn.39a780b1.svg";